import { Link, StatusBar, Text } from "@shared/primitive-components"
import { usePolicyAndFleet } from "../../../contexts"
import { rebatesStyles as styles } from "../../styles"
import { usePolicyDocuments } from "../../../api/policy/documents"

export const RebatesSummaryInfoBar = () => {
  const { policy } = usePolicyAndFleet()
  const [res] = usePolicyDocuments({ id: policy.id })
  const error = res.result?.tag === `err`

  if (error || res.loading) return null

  const documents = res.result?.data ?? []
  const handbookUrl = documents.find(({ key }) => /handbook/i.test(key))

  return handbookUrl ? (
    <StatusBar
      type="info"
      placement="bottom"
      message={
        <Text css={styles.disclaimerText}>
          For further information on how your Safety Score, Estimated Mileage and Loss Ratio are calculated, please
          refer to your
          <Link css={styles.disclaimerLink} href={handbookUrl.url} target="_blank noopener noreferrer">
            Policy Handbook
          </Link>
          .
        </Text>
      }
    />
  ) : null
}
